import React, { useState, useEffect } from 'react';
import { setSelectUserdata } from '../../../../../redux/checkoutredux/actions/checkoutactions/checkoutActions';

const BlockAccount = ({ store }) => {
  // Zugriff auf den aktuellen Zustand des Benutzers
  const initialState = store.getState().checkoutcontext?.checkoutcontextall?.checkoutcontextinitial?.user_info || {};

  console.log("Initial State: ", initialState);
  
  const [localUserData, setLocalUserData] = useState({
    name: initialState.name || '',
    email: initialState.email || '',
    isLoggedIn: initialState.login || false,
  });

  // Holen der initialen E-Mail
  const initialEmail = store.getState().checkoutcontext?.checkoutcontextall?.checkoutcontextselect?.select_userdata?.email || '';
  console.log("INITIAL-Email: ", initialEmail);

  // Effekt zum Setzen der Benutzerdaten
  useEffect(() => {
    const currentState = store.getState().checkoutcontext?.checkoutcontextall?.checkoutcontextinitial?.user_info;
    const initialEmail = store.getState().checkoutcontext?.checkoutcontextall?.checkoutcontextselect?.select_userdata?.email || '';
    if (currentState) {
      setLocalUserData({
        name: currentState.name || '',
        email: initialEmail !== '' ? initialEmail : currentState.email || '',   // Verwende initialEmail, wenn sie nicht leer oder null ist
        isLoggedIn: currentState.login || false,
      });
      
      // Setze die Benutzerdaten, wenn der Benutzer angemeldet ist und die E-Mail nicht leer ist
      if (currentState.login && currentState.email) {
        store.dispatch(setSelectUserdata({ email: currentState.email }));
      }
    }
  }, [store]);
  // Handler für die E-Mail-Änderung
  const handleEmailChange = (e) => {
    const { value } = e.target;
    console.log("E-Mail: ", value);
    setLocalUserData(prevState => ({
      ...prevState,
      email: value,
    }));
    store.dispatch(setSelectUserdata({ email: value }));
  };

  // Handler zum Erstellen eines Kontos
  const handleCreateAccount = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // E-Mail-Regex für Validierung
    if (!emailPattern.test(localUserData.email)) {
      alert("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
      return;
    }
    store.dispatch(setSelectUserdata({ email: localUserData.email }));
  };

  // Effekt zum Abonnieren von Änderungen im Redux-Store
  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      const currentState = store.getState();
      if (currentState.userdata?.userData) {
        setLocalUserData(prevState => ({
          ...prevState,
          email: currentState.userdata.userData.email || '',
        }));
      }
    });
    return () => unsubscribe();
  }, [store]);

  return (
    <div id="ips-account-details" className="ips-module">
      <div className="row g-3">
        <h4 className="mb-3">Information</h4>

        {localUserData.isLoggedIn ? (
          <LoggedInUserMessage user={localUserData} />
        ) : (
          <LoggedOutUserMessage />
        )}

        {/* Zeige das Eingabefeld für die E-Mail nur, wenn der Benutzer nicht angemeldet ist */}
        {!localUserData.isLoggedIn && (
          <EmailInput email={localUserData.email} onChange={handleEmailChange} />
        )}
        
        {!localUserData.isLoggedIn && <CreateAccountCheckbox />}
      </div>
    </div>
  );
};

// Komponente für angemeldeten Benutzer
const LoggedInUserMessage = ({ user }) => (
  <div className="col-12">
    <div className="ips-have-acc-text ips-small">
      <span>Willkommen zurück, <strong>{user.name}</strong> ({user.email}).</span>
      <a href={`${window.appCheckoutSettings.base_url}/wp-login.php?action=logout`}>Abmelden.</a>
    </div>
  </div>
);

// Komponente für nicht angemeldeten Benutzer
const LoggedOutUserMessage = () => (
  <div className="col-12">
    <div className="ips-have-acc-text ips-small">
      <span>Bereits registriert bei uns?</span>
      <a href="javascript:" id="ips-login-modal-trigger" data-modaal-scope="modaal_1711738599371c8ba18cd15301">
        Anmelden.
      </a>
    </div>
  </div>
);

// Eingabefeld für die E-Mail
const EmailInput = ({ email, onChange }) => (
  <div className="col-12">
    <div className="input-group has-validation">
      <span className="input-group-text">@</span>
      <input 
        type="email" 
        className="form-control" 
        id="useremail" 
        placeholder="E-mail address"
        value={email} 
        onChange={onChange} 
        required 
        aria-label="E-Mail Adresse"
      />
      <div className="invalid-feedback">Ihr Benutzername ist erforderlich.</div>
    </div>
  </div>
);

// Checkbox für die Kontoerstellung
const CreateAccountCheckbox = () => (
  <div className="col-12">
    <div className="form-check">
      <input type="checkbox" className="form-check-input" id="same-address" />
      <label className="form-check-label" htmlFor="same-address">Erstelle ein Einkaufskonto</label>
    </div>
  </div>
);

export default BlockAccount;